import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from './account/account.routes';
import agent from './agents/agent.routes';
import assignmentPolicy from './assignmentPolicy/assignmentPolicy.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import canned from './canned/canned.routes';
import inbox from './inbox/inbox.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import macros from './macros/macros.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import sla from './sla/sla.routes';
import teletelFlows from './teletelFlows/flows.routes';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import profile from './profile/profile.routes';
import security from './security/security.routes';
import conversationWorkflow from './conversationWorkflow/conversationWorkflow.routes';
import teletelAuditTrail from './teletelAuditTrail/teletelAuditTrail.routes';
import teletelRoles from './teletelRoles/teletelRoles.routes';
import teletelAssistant from './teletelAssistant/teletelAssistant.routes';
import teletelAdvisor from './teletelAdvisor/teletelAdvisor.routes';
import teletelTeamPresence from './teletelTeamPresence/teletelTeamPresence.routes';
import teletelRequiredAttributes from './teletelRequiredAttributes/teletelRequiredAttributes.routes';
import teletelCsatReviewNotes from './teletelCsatReviewNotes/teletelCsatReviewNotes.routes';
import teletelBranding from './teletelBranding/teletelBranding.routes';
import teletelMetaGuide from './teletelMetaGuide/teletelMetaGuide.routes';
import teletelMeta from './teletelMeta/teletelMeta.routes';
import teletelLifecycle from './teletelLifecycle/teletelLifecycle.routes';
import teletelIntegrations from './teletelIntegrations/teletelIntegrations.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
      redirect: to => {
        if (
          store.getters.getCurrentRole === 'administrator' &&
          store.getters.getCurrentCustomRoleId === null
        ) {
          return { name: 'general_settings_index', params: to.params };
        }

        return { name: 'canned_list', params: to.params };
      },
    },
    ...account.routes,
    ...agent.routes,
    ...assignmentPolicy.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...automation.routes,
    ...auditlogs.routes,
    ...billing.routes,
    ...canned.routes,
    ...inbox.routes,
    ...integrations.routes,
    ...labels.routes,
    ...macros.routes,
    ...reports.routes,
    ...sla.routes,
    ...teletelFlows.routes,
    ...teams.routes,
    ...customRoles.routes,
    ...profile.routes,
    ...security.routes,
    ...conversationWorkflow.routes,
    ...teletelAuditTrail.routes,
    ...teletelRoles.routes,
    ...teletelAssistant.routes,
    ...teletelAdvisor.routes,
    ...teletelTeamPresence.routes,
    ...teletelRequiredAttributes.routes,
    ...teletelCsatReviewNotes.routes,
    ...teletelBranding.routes,
    ...teletelMetaGuide.routes,
    ...teletelMeta.routes,
    ...teletelLifecycle.routes,
    ...teletelIntegrations.routes,
  ],
};
